import { render, staticRenderFns } from "./InviteCandidate.vue?vue&type=template&id=52ce89bb&scoped=true"
import script from "./InviteCandidate.vue?vue&type=script&lang=js"
export * from "./InviteCandidate.vue?vue&type=script&lang=js"
import style0 from "./InviteCandidate.vue?vue&type=style&index=0&id=52ce89bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce89bb",
  null
  
)

export default component.exports